/* Built by Alpas Made. */
/*
 * Credit rules shared by every surface in the theme that reads the member's
 * dashboard (GET /apps/credits/dashboard): My Membership (credit-dashboard.js)
 * and the credit download on a product (credit-download.js). One copy, so the
 * two can never disagree about who is offered what.
 *
 * window.KCCreditRules.packsAllowed(d)
 *   True when the credit packs may be offered: the member has a credit
 *   account (the dashboard says member is not false) and the membership is
 *   active. The server refuses a pack bought without the member tag and flags
 *   the order for a refund, and credits bought in grace or after cancelling
 *   stay frozen, so offering packs to anyone else would sell something that
 *   is taken back or cannot be spent.
 *
 * Callers fail closed: if this file did not load, they offer no packs.
 */
(function () {
  'use strict';

  if (window.KCCreditRules) return;

  function packsAllowed(d) {
    return !!d && d.member !== false && d.status === 'active';
  }

  window.KCCreditRules = { packsAllowed: packsAllowed };
})();
